import Vue from 'vue'
import VueI18n from 'vue-i18n'

// 本地语言包
const enLocale = {
  'header-home': 'HOME',
  'header-game': 'GAMES',
  'header-new': 'NEWS',
  'header-contact': 'CONTACT US',
  'header-language': 'LANGUAGE',

  'about-title': 'Only great creative games for passion',
  'about-content': 'We will keep crafting game memories that stir the soul, so every player can find a passion-rooted sense of belonging and freshness in our games.',
  'about-games': 'Our Games',
  'about-updates': 'Latest Updates',

  'game-title': 'OUR GAMES',
  'game-coming': 'Coming',
  'game-soon': 'soon',

  'new-title': 'OUR NEWS',
  'new-read': 'Read more',
  'new-all': 'Browse all the news',
  'news-title-black': 'OUR\u00A0',
  'news-title-purple': 'NEWS',
  'news-sort': 'All news',
  'news-detail': 'For more details',
  'news-no-more': 'No updates for now',
  'new-info-main': 'Main text',

  'contact-title': 'CONTACT US',
  'contact-email': 'Email contact'
}

Vue.use(VueI18n)

// 创建 i18n 实例（初始为空，后续动态注入语言包）
const i18n = new VueI18n({
  locale: 'en', // 默认语言
  fallbackLocale: 'en', // 语言包加载失败时的备用语言
  messages: {} // 初始为空，后续动态添加
})

// 远程语言包的基础 URL（第三方服务器地址）
const LOCALE_BASE_URL = 'https://static.nemojoy.hk/static/os18n'

// 动态加载语言包的函数
export const loadRemoteLocale = async(langList) => {
  langList.map(async lang => {
    await loadSingleLocale(lang)
  })
}

export const loadSingleLocale = async(lang) => {
  try {
    // 1. 检查是否已加载过该语言包（避免重复请求）
    if (i18n.messages[lang]) {
      i18n.locale = lang // 已加载则直接切换
      return
    }
    // 2. 从第三方服务器请求语言包
    const request = await fetch(`${LOCALE_BASE_URL}/${lang}.json`)
    const data = await request.json()
    i18n.setLocaleMessage(lang, data)
  } catch (error) {
    i18n.setLocaleMessage(lang, enLocale)
    // eslint-disable-next-line require-atomic-updates
    i18n.locale = 'en'
    console.error(`加载语言包失败, 使用本地备用包：`, error)
  }
}

export default i18n
